import React, { useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { timingFunctions } from 'polished';

import StoreThemeProvider from './theme';
import Content from './Content';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
`;

const Card = styled.div`
  position: relative;
  width: 100%;
  max-width: 560px;
  margin-top: 450px;

  /* margin-top: 500px; */
  opacity: 0;
  animation:
    fadeInCard 1800ms 200ms forwards;
    /* fadeInCard 1500ms 200ms forwards ${timingFunctions('easeOutQuint')}; */

  @keyframes fadeInCard {
    100% { 
      opacity: 1;
      /* margin-top: 450px; */
    }
  }
`;

const Logo = styled.img`
  width: 100%;
  max-width: 300px;
  position: fixed;
  top: 50%;
  left: 50%;

  opacity: 0;
  transform: translate(-50%, -50%) scale(1.2);
  animation:
    fadeInLogo 2000ms 500ms forwards ${timingFunctions('easeOutQuint')};
  @keyframes fadeInLogo {
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
`;

const GlobalStyle = createGlobalStyle`
  #admin #main #content {
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .ant-layout {
    background: none !important;
  }

  #admin-line-loader,
  .custom-action-floating-button {
    display: none !important;
  }

  body {
    background: white;
    background: ${({ backgroundColor }) => backgroundColor} !important;
  }

  body, html {
    height: 100vh !important;
  }
`;

const Fullscreen = styled.div`
  position: relative;
  background: white;
  background: ${({ backgroundColor }) => backgroundColor};
  
  &:before {
    content: '';
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    background: white;
    background: ${({ backgroundColor }) => backgroundColor};
  }
`;

function enterFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

const POS = ({ store, order, outlet }) => {
  const fullscreenRef = useRef(null);

  return (
    <StoreThemeProvider data={store}>
      {!outlet ? (
        <Content store={store} order={order} />
      ) : (
        <Fullscreen
          ref={fullscreenRef}
          backgroundColor={store?.posBackgroundColor}
        >
          <GlobalStyle backgroundColor={store?.posBackgroundColor} />
          {order !== null ? (
            <Wrapper>
              <Card>
                <Content store={store} order={order} outlet />
              </Card>
            </Wrapper>
          ) : (
            <Logo
              src={store?.logo?.src}
              onClick={() => enterFullscreen(fullscreenRef.current)}
            />
          )}
        </Fullscreen>
      )}
    </StoreThemeProvider>
  );
};

export default POS;
